import { jsx } from 'react/jsx-runtime';
import { Network } from '../Network/Network.js';

const NetworkAction = ({ iconUrl, networkId, network, onClick, networkName, checkboxClassName = '', newNetworkId, }) => (jsx("div", Object.assign({ className: 'network-action', onClick: () => onClick(networkId), "data-testid": 'network-action' }, { children: jsx(Network, { iconUrl: iconUrl, isActive: networkId === network, networkName: networkName, checkboxClassName: checkboxClassName, isChanging: newNetworkId === networkId }) })));

export { NetworkAction };
